import React, { useState, useEffect } from 'react';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';
import { discoverGalleryPhotos, mergeGalleryPhotos } from '../utils/photoDiscovery';
import './EnhancedComponents.css';

const WeddingGallery = () => {
  const [photos, setPhotos] = useState(galleryData.wedding || []);
  const [loading, setLoading] = useState(false);
  const [discoveredCount, setDiscoveredCount] = useState(0);

  // Discover additional photos from S3
  useEffect(() => {
    const loadDiscoveredPhotos = async () => {
      setLoading(true);
      try {
        const discoveredPhotos = await discoverGalleryPhotos('wedding');
        const mergedPhotos = mergeGalleryPhotos(galleryData.wedding || [], discoveredPhotos);
        setPhotos(mergedPhotos);
        setDiscoveredCount(discoveredPhotos.length);
      } catch (error) {
        console.warn('Could not load discovered photos:', error);
        // Fallback to static photos
        setPhotos(galleryData.wedding || []);
      } finally {
        setLoading(false);
      }
    };

    loadDiscoveredPhotos();
  }, []);

  const refreshPhotos = async () => {
    setLoading(true);
    try {
      const discoveredPhotos = await discoverGalleryPhotos('wedding');
      const mergedPhotos = mergeGalleryPhotos(galleryData.wedding || [], discoveredPhotos);
      setPhotos(mergedPhotos);
      setDiscoveredCount(discoveredPhotos.length);
    } catch (error) {
      console.warn('Could not refresh photos:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="wedding" className="section wedding-section">
      <div className="section-header">
        <img src="/images/rossetti.png" alt="Wedding" className="section-icon" />
        <h1>Family Wedding Gallery</h1>
      </div>

      <div className="wedding-content">
        <p className="welcome-text">
          A collection of precious wedding moments from our family history. 
          These photos capture the joy, love, and traditions that have been 
          passed down through generations of the Rossetti and De Marco families.
        </p>

        {/* Loading indicator */}
        {loading && (
          <div className="loading-indicator">
            <i className="fas fa-spinner fa-spin"></i>
            Discovering new photos...
          </div>
        )}
      </div>

      {/* Wedding Photo Gallery */}
      <Gallery 
        images={photos} 
        sectionName="matrimonio,  marriage,  casamiento" 
        thumbnailSize={250}
        showCaptions={true}
      />

      {/* Photo Statistics and Controls - After Gallery */}
      <div className="wedding-footer">
        {/* Photo Statistics */}
        <div className="photo-stats">
          <div className="stat-item">
            <strong>Total Photos:</strong> {photos.length}
          </div>
          {discoveredCount > 0 && (
            <div className="stat-item">
              <strong>Recently Added:</strong> {discoveredCount}
            </div>
          )}
          <div className="stat-item">
            <strong>Gallery:</strong> Wedding Memories
          </div>
        </div>

        {/* Gallery Controls */}
        <div className="gallery-controls">
          <button className="cta-btn primary" onClick={refreshPhotos} disabled={loading}>
            <i className="fas fa-sync-alt"></i>
            {loading ? 'Refreshing...' : 'Refresh Photos'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default WeddingGallery;